import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";
import { CustomerListResponse } from "../Customer/Customer.constants";

export interface AppointmentModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
  customerListData?: CustomerListResponse | undefined;
  mutate?: UseMutateFunction<
    AppointmentListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface AppointmentDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
  customerListData?: CustomerListResponse | undefined;
}

export interface AppointmentAddRequest {
  customer: string;
  appointment_type: number;
  note: string;
  appointment_datetime: Date;
  is_completed?: boolean;
}

export interface AppointmentAddResponse {
  appointment_type: number;
  note: string;
  appointment_datetime: Date;
  is_completed: boolean;
  status: number;
}

export interface AppointmentUpdateRequest {
  id?: string;
  customer?: string;
  appointment_type?: number;
  note?: string;
  appointment_datetime?: Date;
  is_completed?: boolean;
}

export interface AppointmentUpdateResponse {
  appointment_type: number;
  note: string;
  appointment_datetime: Date;
  is_completed?: boolean;
  status: number;
}

export interface AppointmentDeleteRequest {
  id: string;
}

export interface AppointmentDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

interface Appointment {
  customer: number;
  appointment_type: number;
  note: string;
  appointment_datetime: string;
  is_completed: boolean;
}

export interface AppointmentListResponse extends Array<Appointment> {}

export const appointmentAddSchema = yup.object().shape({
  customer: yup.string().required("Bu Alan boş bırakılamaz"),
  note: yup.string().required("Bu Alan boş bırakılamaz"),
  appointment_datetime: yup.date().required("Randevu tarihi boş bırakılamaz"),
  // created_date: yup.date().required("Açıklama boş bırakılamaz"),
});

export const appointmentUpdateSchema = yup.object().shape({
  customer: yup.string().required("Bu Alan boş bırakılamaz"),
  note: yup.string().required("Bu Alan boş bırakılamaz"),
  appointment_datetime: yup.date().required("Açıklama boş bırakılamaz"),
});

export const appointmentType = {
  INSTALLATION: 1,
  MAINTANENCE: 2,
  INFO: 3,
  OTHER: 4,
};

export const appointmentFormatter = (appointmentType?: number) => {
  if (appointmentType == 1) return "Montaj";
  if (appointmentType == 2) return "Bakım";
  if (appointmentType == 3) return "Bilgi";

  return "Diğer";
};
